// Videos de treinamento do modulo Manual (pedido do Ruan, 29/09/2026). Cinco vendedores entraram
// em tres semanas de setembro e tres desistiram em ate 4 dias — na leitura dele, pela QUANTIDADE
// de informacao nova. Por isso a trilha e' de videos curtos, um assunto cada, na ordem em que se
// devem assistir.
//
// Desde 30/09/2026 a lista mora no BANCO e se edita em "Gerenciar videos" (so admin) — publicar
// deixou de exigir deploy (0304). Os videos vem agrupados em SECOES (0305: "1. Orcamentos",
// "2. Caixa", mesmo desenho do Manual escrito) e numerados "1.01" pela ordem.
import { useCallback, useEffect, useState } from 'react';
import { numeroVideoTreinamento } from '@fiodecobre/shared';
import { api, ApiError } from '../../lib/api';

export type PerguntaEquipe = { id: number; pergunta: string; alternativas: string[] };

export type VideoTreinamento = {
  id: number;
  slug: string;
  titulo: string;
  resumo: string;
  arquivo: string;
  duracao: string | null;
  secao_id: number;
  secao_nome: string;
  perguntas: PerguntaEquipe[];
};

export type VideoNumerado = VideoTreinamento & { numero: string };
export type SecaoComVideos = { id: number; nome: string; numero: number; videos: VideoNumerado[] };

/** Agrupa a lista (ja vem na ordem certa do servidor) em secoes e numera "1.01". */
export function agruparPorSecao(videos: VideoTreinamento[]): SecaoComVideos[] {
  const secoes: SecaoComVideos[] = [];
  for (const v of videos) {
    let s = secoes[secoes.length - 1];
    if (!s || s.id !== v.secao_id) {
      s = { id: v.secao_id, nome: v.secao_nome, numero: secoes.length + 1, videos: [] };
      secoes.push(s);
    }
    s.videos.push({ ...v, numero: numeroVideoTreinamento(s.numero, s.videos.length + 1) });
  }
  return secoes;
}

/** Os videos publicados, na ordem. `recarregar` e' chamado depois de gerenciar. */
export function useVideosTreinamento() {
  const [videos, setVideos] = useState<VideoTreinamento[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const recarregar = useCallback(() => {
    setErro(null);
    api.get<VideoTreinamento[]>('/api/treinamento/videos')
      .then(setVideos)
      .catch((e) => setErro(e instanceof ApiError ? e.message : 'Não foi possível carregar os vídeos.'));
  }, []);
  useEffect(() => { recarregar(); }, [recarregar]);
  return { videos, erro, recarregar };
}
